import { useQuery } from '@tanstack/react-query'
import { useHost } from '../host'

/**
 * The name to show for a user. An embedding host may name its own users
 * (`userLabel`): the API holds no names for the users it mints them, so
 * otherwise they read as "User 1a2b3c4d". Asked once per user and kept.
 */
export function usePersonLabel(userId: string | null | undefined, fallback: string): string {
  const { userLabel } = useHost()
  const { data } = useQuery({
    queryKey: ['person-label', userId],
    queryFn: async () => (await userLabel!(userId!)) ?? null,
    enabled: Boolean(userLabel && userId),
    staleTime: Infinity,
    retry: false,
  })
  return data || fallback
}

/** A person's name inline, resolved as `usePersonLabel` does. */
export function PersonName({ id, fallback }: { id: string | null | undefined; fallback: string }) {
  return <>{usePersonLabel(id, fallback)}</>
}

/** "Aminata Koné" → "AK", as the API derives initials from a full name. */
export const initialsOf = (name: string) =>
  name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? '').join('')
